import ApiMethods from 'shared/api/api-methods';
import type { Tariffs, TariffServiceType } from '@/enteties/tariff/modal';
import { queryOptions } from '@tanstack/react-query';
import { tariffKeys } from '@/enteties/tariff/api/tariff.query-key';
import type {
  QuotaFormValues,
  TariffFormValues,
} from '@/widgets/project-creation-stepper/model';
import { type Quota } from '@/enteties/postgresql/model';

const allTariffs = {
  getTariffs: async function getTariffs(
    service_type?: TariffServiceType
  ): Promise<Tariffs> {
    const data = await ApiMethods.get(
      `/tariff?currency=RUB${service_type ? `&service_type=${service_type}` : ''}`
    );
    if (!data.ok) throw Error(`${data.status}`);
    return data.json();
  },
  getAllTariffsQueryOptions: (service_type?: TariffServiceType) =>
    queryOptions({
      queryKey: tariffKeys.tariffs(service_type),
      queryFn: () => allTariffs.getTariffs(service_type),
      select: (data) => data.tariffs,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    }),
};

const createQuota = async function createQuota(
  params: Required<Omit<TariffFormValues, 'name'>> & { slug: string }
): Promise<{ status: string }> {
  const { slug, ...rest } = params;
  const data = await ApiMethods.post(`/projects/${slug}/resource-quota`, rest);
  if (!data.ok) throw Error(`${data.status}`);
  return data.json();
};

const getQuota = {
  fetchQuota: async function fetchQuota(slug: string): Promise<Quota> {
    const data = await ApiMethods.get(`/projects/${slug}/resource-quota`);
    if (!data.ok) throw Error(`${data.status}`);
    return data.json();
  },
  queryOptions: (slug: string) =>
    queryOptions({
      queryKey: tariffKeys.quota(slug),
      queryFn: () => getQuota.fetchQuota(slug),
    }),
};

const changeQuota = async function changeQuota({
  slug,
  params,
}: {
  slug: string;
  params: Pick<QuotaFormValues, 'resourceType' | 'quota'>;
}): Promise<{ status: string }> {
  const data = await ApiMethods.post(
    `/projects/${slug}/resource-quota`,
    params
  );
  if (!data.ok) throw Error(`${data.status}`);
  return data.json();
};

export { allTariffs, changeQuota, createQuota, getQuota };
